import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from '../../services/payment.service';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-payment-success',
  template: `
    <div class="container mt-5">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card text-center">
            <div class="card-body">
              <div *ngIf="isLoading" class="text-center">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Đang xử lý...</span>
                </div>
                <p class="mt-3">Đang xác nhận thanh toán...</p>
              </div>
              
              <div *ngIf="!isLoading && paymentSuccess" class="text-success">
                <i class="fa fa-check-circle fa-4x mb-3"></i>
                <h3>Thanh toán thành công!</h3>
                <p>Mã giao dịch: <strong>{{ transactionId }}</strong></p>
                <p>Cảm ơn bạn đã sử dụng dịch vụ của chúng tôi.</p>
                <button class="btn btn-primary" (click)="goToPaymentCenter()">
                  Quay lại danh sách đơn hàng
                </button>
              </div>
              
              <div *ngIf="!isLoading && !paymentSuccess" class="text-danger">
                <i class="fa fa-times-circle fa-4x mb-3"></i>
                <h3>Thanh toán thất bại!</h3>
                <p>{{ errorMessage }}</p>
                <button class="btn btn-warning" (click)="goToPaymentCenter()">
                  Thử lại
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  standalone: true,
  imports: [CommonModule]
})
export class PaymentSuccessComponent implements OnInit {
  isLoading = true;
  paymentSuccess = false;
  transactionId = '';
  errorMessage = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private paymentService: PaymentService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.handlePaymentResult(params);
    });
  }

  private async handlePaymentResult(params: any): Promise<void> {
    try {
      // Xử lý kết quả VNPay
      if (params['vnp_ResponseCode']) {
        if (params['vnp_ResponseCode'] === '00') {
          this.paymentSuccess = true;
          this.transactionId = params['vnp_TxnRef'];
          await this.paymentService.updatePaymentStatus(this.transactionId, 'success');
          this.toastr.success('Thanh toán VNPay thành công!', 'Thành công');
        } else {
          this.paymentSuccess = false;
          this.errorMessage = 'Thanh toán VNPay thất bại. Mã lỗi: ' + params['vnp_ResponseCode'];
          await this.paymentService.updatePaymentStatus(params['vnp_TxnRef'], 'failed');
        }
      }
      // Xử lý kết quả MoMo
      else if (params['resultCode']) {
        if (params['resultCode'] === '0') {
          this.paymentSuccess = true;
          this.transactionId = params['orderId'];
          await this.paymentService.updatePaymentStatus(this.transactionId, 'success');
          this.toastr.success('Thanh toán MoMo thành công!', 'Thành công');
        } else {
          this.paymentSuccess = false;
          this.errorMessage = 'Thanh toán MoMo thất bại. Mã lỗi: ' + params['resultCode'];
          await this.paymentService.updatePaymentStatus(params['orderId'], 'failed');
        }
      }
      else {
        this.paymentSuccess = false;
        this.errorMessage = 'Không thể xác định kết quả thanh toán';
      }
    } catch (error) {
      console.error('Error handling payment result:', error);
      this.paymentSuccess = false;
      this.errorMessage = 'Có lỗi xảy ra khi xử lý kết quả thanh toán';
    } finally {
      this.isLoading = false;
    }
  }

  goToPaymentCenter(): void {
    this.router.navigate(['/payment-center']);
  }
}